import * as Yup from 'yup'

export const validationSchemas = Yup.object().shape({
    idCode: Yup.string()
        .required('کد ملی اجباری است')
        .length(10, 'شماره ملی باید ۱۰ کاراکتر داشته باشد.'),
})
